import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

// Matches the Event model default, for events with no timezone recorded
const DEFAULT_TIMEZONE = 'America/Denver'

export const eventTimezone = (event) => event?.timezone || DEFAULT_TIMEZONE

/**
 * Whether the event's first day has arrived, read in the event's own timezone.
 *
 * Inclusive of the start date: EXEC-374 scoped reassignment as available "up until the
 * event start date", locked down "at event start", so the start date itself is closed.
 *
 * Mirrors `event_has_started` on the API, which is what actually enforces the cutoff.
 * @param {object} event
 */
export const hasEventStarted = (event) => {
  if (!event?.startsAt) return false

  const zone = eventTimezone(event)

  return !dayjs().tz(zone).isBefore(dayjs.tz(event.startsAt, zone))
}

/**
 * Whether the event's last day is behind us, read in the event's own timezone.
 *
 * "Conclusion" is the end date at midnight, so this stays false for the whole of the
 * final day. Comparing in the browser's timezone instead gets it wrong in both
 * directions: an admin in New York would see a Los Angeles event as concluded while
 * its last evening is still running, and an admin in Los Angeles would see a New York
 * event as still going after it had finished.
 *
 * Mirrors `event_has_concluded` on the API, which is what actually enforces the cutoff.
 * @param {object} event
 */
export const hasEventConcluded = (event) => {
  if (!event?.endsAt) return false

  const zone = eventTimezone(event)

  return dayjs().tz(zone).isAfter(dayjs.tz(event.endsAt, zone), 'day')
}
